import React, { useEffect, useState } from "react";

import {
  authIranianItems,
  authNonIranianItems,
  businessLegalItems,
  businessRealItems,
} from "../../lib/constants";

const UploadMenu = ({ setActiveUplaodMenu, type, value }) => {
  const getMenuItems = () => {
    if (type === "auth") {
      return value ? authIranianItems : authNonIranianItems;
    } else if (type === "business") {
      return value ? businessRealItems : businessLegalItems;
    }
    return [];
  };

  const [items, setItems] = useState(getMenuItems);

  useEffect(() => {
    setItems(getMenuItems());
  }, [type, value]);

  const onClickHandler = (e, value) => {
    e.preventDefault();
    setItems(
      items.map((item) => (item.value === value ? { ...item, active: true } : { ...item, active: false })),
    );
  };

  useEffect(() => {
    setActiveUplaodMenu(items.find((item) => item.active));
  }, [items, setActiveUplaodMenu]);

  return (
    <div className="flex p-1 bg-neutral-20 gap-2 h-[53px] rounded-v-md pointer-events-auto text-[14px] md:text-[16px]">
      {items.map((item) => (
        <button
          key={item.value}
          value={item.value}
          onClick={(e) => onClickHandler(e, item.value)}
          className={`flex-1 ${item.active ? "bg-neutral-00" : ""} rounded-v-md flex justify-center items-center cursor-pointer`}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
};

export default UploadMenu;
